export enum SmartLabelPref {
	IMAGE_ENABLED = 'metadata.smartLabels.enabled',
	VIDEO_ENABLED = 'metadata.smartLabels.video.enabled',
	IMAGE_AVAILABLE = 'metadata.smartLabels.available',
	VIDEO_AVAILABLE = 'metadata.smartLabels.video.available',
}

export enum SmartLabelProperty {
	CONFIDENCE_THRESHOLD = 'metadata.smartLabels.minConfidence',
}
